export type NavigationGuard = (proceed: () => void) => void;

// The sidebar, top bar and page mount as separate React roots and exit with
// full page loads, so the guard lives at module scope, not in context or the router.
let activeGuard: NavigationGuard | null = null;

export const registerGuard = (guard: NavigationGuard) => {
  activeGuard = guard;
  return () => {
    if (activeGuard === guard) activeGuard = null;
  };
};

export const requestNavigation = (proceed: () => void) => {
  if (activeGuard) {
    activeGuard(proceed);
  } else {
    proceed();
  }
};
